import React, {Component, PropTypes} from 'react';

export default class Checkbox extends Component {
	static propTypes = {
		// checkedItems: PropTypes.any.isRequired,
		value: PropTypes.any.isRequired,
		name: PropTypes.string.isRequired,
		id: PropTypes.string.isRequired,
	};

	state = {
		elementName: null,
		elementId: null,
		label: null,
		itemvalue: 'null',
		checked : false
	};

	handleClick = (e) => {
		let data = this.props.dataRow;
		
		this.props.onchange(e,data);

		this.setState({itemValue : e.target.value, checked : e.target.checked});
	};

	componentDidMount() {
		let nextProps = this.props;
			
		this.setState({
			elementName: nextProps.name,
			elementId: nextProps.id + nextProps.index,
			label: nextProps.label,
			itemValue: nextProps.value
		});
	}

	componentWillReceiveProps(nextProps) {
		// console.log(nextProps)
        // console.log(typeof nextProps.checkedItems);
        
		if(nextProps.value in nextProps.checkedItems) {
			this.setState({checked : true});
		}
	}

	render() {
		return (
			<div className="md-checkbox-list" style={{margin: '15px 0'}}>
				<div className="md-checkbox">
	                <input type="checkbox" checked={this.state.checked} name={this.state.elementName} id={this.state.elementId} className="md-check" value={this.state.itemValue} onClick={this.handleClick}/>
	                <label htmlFor={this.state.elementId}>
	                    <span></span>
	                    <span className="check"></span>
	                    <span className="box"></span> {this.state.label}
	                </label>
	            </div>
			</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/Checkbox.js
 **/